import { defaultLanguage } from '@/i18n'
import { HTTP } from '@/http-common'

// initial state
const state = {
    language: defaultLanguage,
    entrypoint: undefined,
    formStarted: false,
    current: {
        'section': 1,
        'step': 0,
        'sectionCompleted': 0,
        'chapterIntro': true,
        'activeQuestionStep': 0,
        'sectionTitle': 'operationalTransferability'
    },
    metadata: {
        campID: '',
        channel: '',
        aecID: ''
    },
    consent: {
        id: '',
        title: '',
        content: '',
        display: false,
        links: [],
        confirmLabel: '',
        confirmText: '',
        confirmMandatory: false
    }
}

// getters
const getters = {
    currentStep: (state) => state.current['step'],
    chapterIntro: (state) => state.current['chapterIntro'],
    activeQuestionStep: (state) => state.current['activeQuestionStep'],
    section: (state) => state.current['section'],
    sectionCompleted: (state) => state.current['sectionCompleted'],
    sectionTitle: (state) => state.current['sectionTitle'],
    lang: (state) => state.language,
    consent: (state) => state.consent,
    isFormStarted: (state) => state.formStarted
}

// mutations
const mutations = {
    changeLanguage(state, newLanguage) {
        state.language = newLanguage
    },
    setEntrypoint(state, newEntrypoint) {
        state.entrypoint = newEntrypoint
    },
    incrementCurrent(state, variable) {
        state.current[variable]++
    },
    decrementCurrent(state, variable) {
        state.current[variable]--
    },
    setCurrentSection(state, section) {
        state.current['section'] = section
    },
    setCurrentStep(state, step) {
        state.current['step'] = step
    },
    setChapterIntro(state, chapterIntro) {
        state.current['chapterIntro'] = chapterIntro
    },
    setActiveQuestionStep(state, activeQuestionStep) {
        state.current['activeQuestionStep'] = activeQuestionStep
    },
    setSectionCompleted(state, section) {
        state.current['sectionCompleted'] = section
    },
    setsectionTitle(state, sectionTitle) {
        state.current['sectionTitle'] = sectionTitle
    },
    setMetadata: (state, payload) => {
        state.metadata = {
            ...state.metadata,
            ...payload
        }
    },
    setLoading: (state, loading) => {
        state.loading = loading
    },
    setConsent: (state, payload) => {
        state.consent = payload
    },
    setFormStart: (state, bool) => {
        state.formStarted = bool
    }
}

// actions
const actions = {
    set: ({ commit }, payload) => {
        commit('mutate', payload)
    },
    changeLanguage: (context, language) => {
        context.commit('setLanguage', language)
    },
    setMetadata: ({ commit }, payload) => {
        commit('setMetadata', payload)
    },
    setLoading: (context, loading) => {
        context.commit('setLoading', loading)
    },
    loadConsent: async ({ commit, state }) => {
        const payload = {
            language: state.language
        }

        try {
            const response = await HTTP.post('/consent', payload)
            commit('setConsent', response.data)
        } catch (error) {
            console.log('loadConsent() catch()', error.message)
        }
    },
    setFormStart: ({ commit }, bool) => {
        commit('setFormStart', bool)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
